import $ from 'jquery';

export default () => {
	let toggleMenuButtons   = document.querySelectorAll('.js-menu-toggle, .js-main-menu a');
	let submenus            = document.querySelectorAll('.site-nav .submenu');
	let _body               = document.body;
	let prevent             = false;
	let windowHeight        = window.innerHeight;
	let new_scroll_position = 0;
	let last_scroll_position;
	
	Array.prototype.forEach.call(toggleMenuButtons, function (item, index) {
		item.addEventListener('click', function () {
			if (!prevent) {
				prevent = true;
				_body.classList.toggle('menu-show');
				let hamburger = item.querySelectorAll('.hamburger')[0];
				hamburger.classList.toggle('is-active');
				if(this.classList.contains("js-menu-toggle"))
				{
					this.classList.toggle('is-active');
				}

				submenus.forEach(function (item) {
					item.classList.remove('active');
				});

				setTimeout(function () {
					prevent = false;
				}, 600);
			}
		});
	});

	if (window.pageYOffset >= 50) {
		_body.classList.add('fixed-nav', 'scrolled');
	}

	if (window.pageYOffset > (windowHeight - 100)) {
		_body.classList.add('fixed-subnav');
	}

	window.addEventListener('scroll', function () {
		last_scroll_position = window.pageYOffset;

		if (new_scroll_position < last_scroll_position && last_scroll_position > 80) {
			_body.classList.remove('slideDown');
			_body.classList.add('slideUp');
		} else if (new_scroll_position > last_scroll_position) {
			_body.classList.remove('slideUp');
			_body.classList.add('slideDown');
		}

		new_scroll_position = last_scroll_position;

		if (window.pageYOffset >= 50) {
			_body.classList.add('fixed-nav', 'scrolled');
		} else {
			_body.classList.remove('fixed-nav');
		}
	});

};